export default "__VITE_ASSET__CG22O02u__"